// extracted by mini-css-extract-plugin
export default {"pageSkeleton":"PageSkeleton_pageSkeleton__ZfAyF","textLineSkeleton":"PageSkeleton_textLineSkeleton__OfRFJ","skeleton-loading":"PageSkeleton_skeleton-loading__6zMGT"};